// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let BusinessRejectMessage = function (fieldSet)
{
    this.Code = Message.CODE_BUSINESS_REJECT_MESSAGE;
    PFixMessage.call(this, fieldSet)
}
BusinessRejectMessage.prototype = Object.create(PFixMessage.prototype)

BusinessRejectMessage.prototype.getReferanceMessageId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ID);
}
BusinessRejectMessage.prototype.setReferanceMessageId = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_ID, id);
}

BusinessRejectMessage.prototype.getComment = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_COMMENT);
}
BusinessRejectMessage.prototype.setComment = function (comment)
{
    this.setFieldValue(FieldsFactory.FIELD_COMMENT, comment);
}

BusinessRejectMessage.prototype.getErrorCode = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ERROR_CODE);
}

BusinessRejectMessage.REQUEST_CODE_IS_NOT_SUPPORTED = 39;
BusinessRejectMessage.ERROR_SERVER_HISTORY_QUEUE_WAS_OVERFLOWED = 414;
BusinessRejectMessage.NO_TRADES_OCCURING_CURRENT_DAY = 452;